// Relative-time formatting for the end-user conversation list (fn-48).
//
// `Intl.RelativeTimeFormat` with a COMPUTED unit (minute → year by
// delta), `numeric: 'auto'` so day-scale deltas read as "yesterday" /
// "last week" instead of "1 day ago" — the Outlook-ish register the
// list wants. Anything under a minute is "just now" (second-level
// precision is noise on a polled list).
//
// NOT a replacement for `internal/inbox/bucketing.ts`'s
// `formatRelativeTime` — that compact form ("5m ago") is
// operator-inbox vocabulary and stays untouched.
//
// en-only for v1, like everything in `internal/copy/` (the i18n seam
// is the copy module; this helper would take a locale there).
import { JUST_NOW } from '../copy/copy.js';
/** Unit thresholds, largest first. Month ≈ 30d, year ≈ 365d. */
const UNITS = [
    ['year', 365 * 86_400_000],
    ['month', 30 * 86_400_000],
    ['week', 7 * 86_400_000],
    ['day', 86_400_000],
    ['hour', 3_600_000],
    ['minute', 60_000],
];
// One formatter for the module — construction is the expensive part.
const RTF = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
/**
 * Human relative time for a conversation row ("5 minutes ago",
 * "yesterday", "last month"; "just now" under a minute). Returns ''
 * for unparseable input — the row simply omits the time rather than
 * rendering "Invalid Date". `now` is a parameter so tests stay
 * deterministic.
 */
export function formatConversationTime(iso, now = Date.now()) {
    const t = new Date(iso).getTime();
    if (!Number.isFinite(t))
        return '';
    const diff = t - now; // negative for the (usual) past case
    const magnitude = Math.abs(diff);
    for (const [unit, unitMs] of UNITS) {
        if (magnitude >= unitMs) {
            return RTF.format(Math.trunc(diff / unitMs), unit);
        }
    }
    return JUST_NOW;
}
//# sourceMappingURL=relative-time.js.map